module.exports = __webpack_public_path__ + "img/Paso2.c286b1f9.svg";